import { render, staticRenderFns } from "./DoctorLead.vue?vue&type=template&id=06390176&scoped=true&"
import script from "./DoctorLead.vue?vue&type=script&lang=js&"
export * from "./DoctorLead.vue?vue&type=script&lang=js&"
import style0 from "./DoctorLead.vue?vue&type=style&index=0&id=06390176&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06390176",
  null
  
)

export default component.exports